import React, { useState, useEffect, useCallback } from "react";
import * as moment from "moment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import ReactTable from "components/ReactTable";
import AccordionTable from "components/AccordionTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { orderList, cancelOrderApiCall } from "redux/actions/manageOrders";
import ConfirmationModal from "components/ConfirmationModal";
import AlertModal from "components/AlertModal";
import Pagination from "components/pagination";
import { TabsWrapper } from "assets/css/global";
import { getStateAbbr, getLoggedInUserCountry } from 'helpers'

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const OrderTab = ({
  sort,
  search,
  getFromDate,
  getToDate,
  orderType,
  deliveryReq,
  locationIds,
  callBack,
  locale,
}) => {
  const [value, setValue] = useState(0);
  const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userCountry = getLoggedInUserCountry();

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalContent, setConfirmationModalContent] = useState("");
  const [confirmationModalLink, setConfirmationModalLink] = useState("/");
  const [confirmationAlertType, setConfirmationAlertType] = useState("");
  const toggleConfirmationModal = () =>
    setConfirmationModal(!confirmationModal);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const [orderResponse, setOrderResponse] = useState();
  const [cancelOrderData, setCancelOrderData] = useState();

  const [pageNumber, setPageNumber] = useState(0);
  const [totalPagesCount, setTotalPagesCount] = useState(0);
  const tabStatus = [
    "REQUESTED",
    "ASSIGNED",
    "DELIVER_PICKUP",
    "COMPLETE",
    "CANCELLED",
    "CLAIM",
    "ALL",
    "HOLD",
    "SHIPPED",
    "RESCHEDULED",
    "ASSIGN",
    "DELIVERED",
    "PICKEDUP",
  ];

  const onPageChange = (pagevalue) => {
    setPageNumber(pagevalue);
    let pageValueTemp = pagevalue - 1;
    let tabValue = tabStatus.indexOf(orderType);
    tabValue = tabValue === -1 ? value : tabValue;
    fetchMyAPI(
      pageValueTemp,
      sort,
      search,
      getFromDate,
      getToDate,
      tabValue,
      locationIds,
    );
  };

  useEffect(() => {
    setPageNumber(0);
    let tabValue = value;
    for (let i = 0; i < tabStatus.length; i++) {
      if (orderType === tabStatus[i]) {
        tabValue = i;
      }
    }

    let tabValueTemp = localStorage.getItem("manageOrderTab");
    if (tabValueTemp) {
      setValue(parseInt(tabValueTemp));
      tabValue = parseInt(tabValueTemp);
    }
    localStorage.removeItem("manageOrderTab");
    if (locationIds?.length && locationIds?.length > 0)
      fetchMyAPI(
        0,
        sort,
        search,
        getFromDate,
        getToDate,
        tabValue,
        locationIds,
      );
  }, [
    sort,
    search,
    getFromDate,
    getToDate,
    orderType,
    deliveryReq,
    locationIds,
  ]);

  const fetchMyAPI = useCallback(
    async (
      selectedPage,
      sortType,
      search,
      getFromDate,
      getToDate,
      activeTab,
      locationIds,
    ) => {
      let customerId = loggedInUserInfo?.customerId;
      let locationType = loggedInUserInfo?.locationType;
      let status = tabStatus[activeTab];
      let data = {
        size: 10,
        number: selectedPage === -1 ? 0 : selectedPage,
        sort: sortType ? sortType : "DESC",
        status: status,
        searchBy: search,
        toDate: moment(getToDate).format("YYYY/MM/DD"),
        fromDate: moment(getFromDate).format("YYYY/MM/DD"),
        locations: locationIds,
        locationType,
      };
      let response = await dispatch(
        orderList(data, customerId, loggedInUserInfo?.token),
      );

      if (response?.data?.success) {
        setOrderResponse(response?.data?.data);
        setTotalPagesCount(response?.data?.data?.totalElements);
      } else {
        setOrderResponse();
        setTotalPagesCount(0);
        if (response?.data?.error.message === "Invalid Token") {
          navigate("/");
        } else {
          setModalContent(
            response?.data?.error?.message ||
            response.message ||
            "Someting went wrong, please try again in some time.",
          );
          setModalLink("");
          toggleModal();
        }
      }
    },
    [],
  );

  const handleTabChange = (event, val) => {
    setPageNumber(0);
    setValue(val);
    callBack(val);
    setOrderResponse();

    fetchMyAPI(0, sort, search, getFromDate, getToDate, val, locationIds);
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  let referenceArrHeader = [
    locale("referenceNumber"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("requestedDate"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("action"),
  ];
  let claimTableArrHeader = [
    locale("referenceNumber"),
    "Order ID",
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("requestedDate"),
    // "Canceled By",
    // "Print",
  ];
  // all orders tab
  let accordionTableArrHeader = [
    locale("referenceNumber"),
    locale("orderId"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("requestedDate"),
    locale("status"),
    locale("invoiceNumber"),
    locale("bolPod"),
  ];
  let cancelTableArrHeader = [
    locale("referenceNumber"),
    locale("orderId"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("dateCanceled"),
    locale("canceledBy"),
    locale("comment"),
  ];

  let deliveredTableArrHeader = [
    locale("referenceNumber"),
    locale("orderId"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("actualDeliveryPickupDate"),
  ];

  let completedTableArrHeader = [
    locale("referenceNumber"),
    locale("orderId"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("actualDeliveryPickupDate"),
    locale("invoiceNumber"),
    locale("bolPod"),
  ];

  let cancelOrderTableArrHeader = [
    locale("referenceNumber"),
    locale("orderId"),
    locale("poNumber"),
    locale("locationAddress"),
    locale(userCountry === 'CANADA' ? "cityProv" : "cityState"),
    locale("quantityOrderType"),
    locale("requestType"),
    locale("requestedDate"),
    locale("status"),
    "",
  ];
  const cancelOrderCallback = async (items) => {
    setCancelOrderData(items);
    setConfirmationModalContent("Are you sure you want to cancel the order?");
    setConfirmationAlertType("cancelRequestedOrder");
    setConfirmationModalLink("");
    toggleConfirmationModal();
  };
  const confirmCancelOrderFunction = async (item, comment) => {
    let customerId = loggedInUserInfo?.customerId;
    let locationType = loggedInUserInfo?.locationType;
    let orderId = item?.orderId;
    let referenceId = item?.orderRefNumber;

    let response = await dispatch(
      cancelOrderApiCall(
        locationType,
        customerId,
        loggedInUserInfo?.token,
        referenceId,
        comment,
      ),
    );

    if (response?.data?.success) {
      // fetchMyAPI(pageNumber-1, sort, search, getFromDate, getToDate, value)
      fetchMyAPI(
        pageNumber,
        sort,
        search,
        getFromDate,
        getToDate,
        value,
        locationIds,
      );
      setModalContent("Order Successfully Canceled.");
      setModalLink("");
      toggleModal();
    } else {
      if (response?.data?.error.message === "Invalid Token") {
        navigate("/");
      } else {
        setModalContent(
          response?.data?.error?.message ||
          "Something went wrong, please try again.",
        );
        setModalLink("");
        toggleModal();
      }
    }
  };

  return (
    <>
      <TabsWrapper>
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={value}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={locale("requestedOrders")} {...a11yProps(0)} />
            <Tab label={locale("pendingOrders")} {...a11yProps(1)} />
            <Tab label={locale("finalizedOrders")} {...a11yProps(2)} />
            <Tab label={locale("completedOrders")} {...a11yProps(3)} />
            <Tab label={locale("canceledOrders")} {...a11yProps(4)} />
            <Tab label={locale("claimedOrders")} {...a11yProps(5)} />
            <Tab label={locale("allOrders")} {...a11yProps(6)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <ReactTable
              headerArr={referenceArrHeader}
              response={orderResponse}
              deleteCallback={() =>
                fetchMyAPI(
                  pageNumber - 1,
                  sort,
                  search,
                  getFromDate,
                  getToDate,
                  value,
                  locationIds,
                )
              }
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <AccordionTable
              headerArr={cancelOrderTableArrHeader}
              tableDataList={orderResponse}
              cancelOrderCallback={(item, comment) => {
                confirmCancelOrderFunction(item, comment);
                //cancelOrderCallback}
              }}
              orderType="createdOrder"
            />
            {/* <ReactTable headerArr={cancelOrderTableArrHeader} response={orderResponse} /> */}
          </TabPanel>
          <TabPanel value={value} index={2}>
            <AccordionTable
              headerArr={deliveredTableArrHeader}
              orderType="whiteSpace"
              tableDataList={orderResponse}
            />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <AccordionTable
              headerArr={completedTableArrHeader}
              orderType="whiteSpace"
              tableDataList={orderResponse}
              orderTabName="completedOrders"
            />
          </TabPanel>
          <TabPanel value={value} index={4}>
            {/* <AccordionTable headerArr={accordionTableArrHeader} tableDataList={orderResponse} /> */}
            <AccordionTable
              headerArr={cancelTableArrHeader}
              tableDataList={orderResponse}
            />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <AccordionTable
              headerArr={claimTableArrHeader}
              tableDataList={orderResponse}
            />
          </TabPanel>
          <TabPanel value={value} index={6}>
            <AccordionTable
              headerArr={accordionTableArrHeader}
              tableDataList={orderResponse}
              orderType="All Order"
            />
          </TabPanel>
        </Box>
      </TabsWrapper>

      {orderResponse && (
        <Pagination
          totalPage={totalPagesCount}
          currentPage={pageNumber}
          onPageChange={onPageChange}
        />
      )}

      <ConfirmationModal
        isOpen={confirmationModal}
        toggle={toggleConfirmationModal}
        content={confirmationModalContent}
        link={confirmationModalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={() => {
          if (confirmationAlertType === "cancelRequestedOrder") {
            confirmCancelOrderFunction();
            toggleConfirmationModal();
          } else {
            toggleConfirmationModal();
          }
        }}
      />

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        // title="Alert"
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
      />
    </>
  );
};

export default OrderTab;
